<template>
  <button class="alert-bell" data-qa="alert-bell" @click="emit('click', $event)">
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path fill-rule="evenodd" clip-rule="evenodd"
        d="M7.05097 3.05025C8.36372 1.7375 10.1442 1 12.0007 1C13.8572 1 15.6377 1.7375 16.9505 3.05025C18.2632 4.36301 19.0007 6.14349 19.0007 8C19.0007 10.9127 19.7327 12.8439 20.5001 14.0771L20.5119 14.096C20.8692 14.6703 21.1517 15.1243 21.3421 15.4547C21.4375 15.6202 21.5245 15.7797 21.5888 15.9215C21.621 15.9922 21.6569 16.079 21.685 16.1733C21.7083 16.2515 21.7527 16.4187 21.7361 16.6223C21.7249 16.7591 21.697 16.9928 21.5628 17.2343C21.4287 17.4758 21.2449 17.623 21.1347 17.7047C20.8844 17.8904 20.597 17.9329 20.5011 17.947L20.4966 17.9477C20.3492 17.9695 20.1819 17.9804 20.0132 17.9869C19.6779 18 19.2138 18 18.6366 18H5.36486C4.78764 18 4.3235 18 3.98824 17.9869C3.81949 17.9804 3.65221 17.9695 3.5048 17.9477L3.50036 17.947C3.40443 17.9329 3.11701 17.8904 2.86672 17.7047C2.75648 17.623 2.57275 17.4758 2.4386 17.2343C2.30445 16.9928 2.27656 16.7591 2.26537 16.6223C2.24872 16.4187 2.29312 16.2515 2.31643 16.1733C2.34452 16.079 2.38046 15.9922 2.41259 15.9215C2.47695 15.7797 2.56389 15.6202 2.65931 15.4547C2.84973 15.1243 3.13219 14.6703 3.48949 14.0961L3.50133 14.0771C4.26871 12.8439 5.00071 10.9127 5.00071 8C5.00071 6.14348 5.73821 4.36301 7.05097 3.05025ZM12.0007 3C10.6746 3 9.40286 3.52678 8.46518 4.46447C7.5275 5.40215 7.00071 6.67392 7.00071 8C7.00071 11.2677 6.17366 13.5681 5.19943 15.1337C4.98658 15.4758 4.80894 15.7614 4.6638 15.9988C4.87037 16 5.1107 16 5.38957 16H18.6119C18.8907 16 19.1311 16 19.3376 15.9988C19.1925 15.7614 19.0149 15.4758 18.802 15.1337C17.8278 13.5681 17.0007 11.2677 17.0007 8C17.0007 6.67392 16.4739 5.40215 15.5362 4.46447C14.5986 3.52678 13.3268 3 12.0007 3ZM8.60515 20.3383C8.97062 19.9242 9.60255 19.8848 10.0166 20.2503C10.5461 20.7176 11.2392 21 12.0007 21C12.7622 21 13.4553 20.7176 13.9848 20.2503C14.3989 19.8848 15.0308 19.9242 15.3963 20.3383C15.7617 20.7523 15.7223 21.3843 15.3083 21.7497C14.4275 22.5272 13.2681 23 12.0007 23C10.7333 23 9.57397 22.5272 8.69316 21.7497C8.27909 21.3843 8.23969 20.7523 8.60515 20.3383Z"
        fill="#273157" />
    </svg>
    <span v-if="notificationCount > 0" class="alert-bell__badge" data-qa="alert-bell-badge"
      :aria-label="`${notificationCount} notifications`">
      {{ notificationCount }}
    </span>
  </button>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { useAlertsStore } from '@/stores';

const alertsStore = useAlertsStore();

const notificationCount = computed(() => alertsStore.unreadAlertsCount);

const emit = defineEmits<{
  (e: 'click', v: Event): void
}>();
</script>

<style scoped lang="scss">
.alert-bell {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  color: $brand-primary-100-navy;
  cursor: pointer;
  background: none;
  border: none;

  @include new-md {
    display: none;
  }

  &__icon {
    width: 100%;
    height: 100%;
  }

  &__badge {
    position: absolute;
    top: -6px;
    right: -6px;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 16px;
    height: 16px;
    padding: 0 4px;
    font-size: 10px;
    font-weight: 700;
    line-height: 1;
    color: $brand-primary-100-white;
    background-color: $brand-secondary-100-red;
    border-radius: 50%;
  }
}
</style>
